/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 52);
/******/ })
/************************************************************************/
/******/ ({

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_multi_page__ = __webpack_require__(40);


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formSerializeObject; });
/**
 * This gives us data from a form in a way that $.ajax can handle a bit better
 *
 * @param   array  serializeArray  Array of Objects from $( form ).serializeArray()
 *
 * @since   {{VERSION}}
 * @return  object                 Object representation of the same data
 */
var formSerializeObject = function formSerializeObject(serializeArray) {
  var data = {};

  for (var index in serializeArray) {
    data[serializeArray[index].name] = serializeArray[index].value;
  }

  return data;
};



/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_serialize_object__ = __webpack_require__(38);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



(function ($) {
  $(document).on('submit', 'form[id^="gform"]', function (event, bool, buttonID) {
    var $button = $('#' + buttonID);
    if (!$button.hasClass('gform_previous_button')) return;
    $button.closest('.gform_page').find('.gform_page_fields [name]').each(function (index, field) {
      if ($(field).is('input[type="checkbox"], input[type="radio"]')) {
        $(field).attr('checked', false);
      } else {
        $(field).val('');
      }
    });
    var formID = parseInt($(this).attr('id').replace('gform_', '')),
        pageID = parseInt($button.closest('.gform_page').attr('id').replace('gform_page_' + formID + '_', ''));
    $(document).trigger('pws_gform_page_reverted', [$(this), formID, pageID]);
  });
  $(document).on('gform_page_loaded', function (event, formID, currentPage) {
    if (parseInt(currentPage) !== 7 && parseInt(currentPage) !== 15) return;
    if (parseInt(formID) !== 2) return;
    var $form = $('#gform_' + formID);
    $form.find('.gform_next_button').hide();
  });
  $(document).on('gform_post_render', function (event, formID, currentPage) {
    if (parseInt(currentPage) !== 7) return;
    if (parseInt(formID) !== 2) return;
    var subjectFieldID = 'input_2_26',
        // Each choice is a variant of this. We need to grab them all
    htmlID = 'field_2_25',
        $form = $('#gform_' + formID); // These are submitted to Gravity Forms without the Form ID

    subjectFieldID = subjectFieldID.replace('_' + formID, '');
    var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__form_serialize_object__["a" /* formSerializeObject */])($form.serializeArray()); // Grab only the appropriate values from the previous Page's submission

    data = Object.keys(data).filter(function (key) {
      return key.indexOf(subjectFieldID + '.') > -1;
    }).reduce(function (result, key) {
      return Object.assign(result, _defineProperty({}, key, data[key]));
    }, {});
    $.ajax({
      url: '/wp-json/pws/v1/get-related-courses',
      method: 'GET',
      data: data,
      success: function success(response) {
        $('#' + htmlID + ' #logic-based-product-list').html(response.data.html);
      },
      error: function error(request, status, _error) {
        var errorMessage = JSON.parse(request.responseText);

        if (typeof errorMessage.data.message !== 'undefined') {
          console.error(errorMessage.data.message);
        } else if (typeof errorMessage.message !== 'undefined') {
          console.error(errorMessage.message);
        }
      }
    }); // Grab selected option(s) for subjects, send to API endpoint, display links to relevant products based on Pillar
    // Check if the current page is showing the "dynamic field" first so we aren't hitting the API endpoint on every page turn
    // The field should probably get reverted if they go back a page
  });
  $(document).on('pws_gform_page_reverted', function (event, form, formID, pageID) {
    if (parseInt(pageID) !== 7) return;
    if (parseInt(formID) !== 2) return;
    var htmlID = 'field_2_25';
    $('#' + htmlID + ' #logic-based-product-list').html('<img id="gform_ajax_spinner_2" class="gform_ajax_spinner" src="/wp-content/plugins/gravityforms/images/spinner.svg" alt="">');
  });
})(jQuery);

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ })

/******/ });
